import React from 'react';
import styled, { keyframes } from 'styled-components';

interface BlurredSnapshotProps {
    snapshotUrl: string | null;
    isVideoReady: boolean;
}

/**
 * компонент для показа заблюренного snapshot'а видео
 * исчезает когда реальное видео готово
 */
export const BlurredSnapshot: React.FC<BlurredSnapshotProps> = ({ snapshotUrl, isVideoReady }) => {
    if (!snapshotUrl) {
        return null;
    }

    return (
        <SnapshotContainer $isVideoReady={isVideoReady}>
            <SnapshotImage src={snapshotUrl} alt="" draggable="false" />
        </SnapshotContainer>
    );
};

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

const SnapshotContainer = styled.div<{ $isVideoReady: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    overflow: hidden;

    contain: paint;

    /* Плавное исчезновение когда видео готово */
    opacity: ${({ $isVideoReady }) => ($isVideoReady ? 0 : 1)};
    animation: ${({ $isVideoReady }) => ($isVideoReady ? fadeOut : 'none')} 0.4s ease-out;

    /* Скрываем после анимации */
    ${({ $isVideoReady }) =>
        $isVideoReady &&
        `
        pointer-events: none;
        transition: opacity 0.4s ease-out;
    `}
`;

const SnapshotImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(4px);
    display: block;
    backface-visibility: hidden;
    user-select: none;
    -webkit-user-drag: none;
`;
